import { createStore, combineReducers } from 'redux';
import { reducer as HeaderReducer } from '@owc-utils/Store/Header/reducer';

const reducers = combineReducers({
  header: HeaderReducer,
});

const store = createStore(reducers);

export default store;
